import { memo, ReactNode, useEffect } from "react";

export type GlobalLoaderRemoverProps = {
  children: ReactNode | ReactNode[],
  loaderId?: string
  duration?: number
}

export async function globalLoaderRemover(loaderId = "global-loader", duration = 125) {
  return new Promise<void>(async resolve => {
    const loaderNode = document.getElementById(loaderId);
    if (loaderNode) {
      loaderNode.style.opacity = "1";
      loaderNode.style.transition = `opacity ${duration}ms linear`;
      loaderNode.style.opacity = "0";
      await new Promise(res => setTimeout(res, duration + 50));
      loaderNode?.remove();
    }
    resolve();
  });
}

export function useGlobalLoaderRemover(loaderId = "global-loader", duration = 125) {
  useEffect(() => {
    globalLoaderRemover(loaderId, duration);
  }, [ loaderId, duration ]);
}

export const GlobalLoaderRemover = memo<GlobalLoaderRemoverProps>(({ children, loaderId, duration }) => {
  useGlobalLoaderRemover(loaderId, duration);

  return (
    <>{children}</>
  );
});